export const openEnrollment = {
  namespaced: true,
  state: {
    userSelections: {}
  },
  mutations: {
    ADD_USER_SELECTIONS(state, payload) {
      state.userSelections = payload
    }
  },
  actions: {
    addUserSelections({ commit }, payload) {
      commit('ADD_USER_SELECTIONS', payload)
    }
  }
}
